import comChart from './comChart.vue'

export default comChart
